<template>
  <v-dialog
    v-model="show"
    width="640"
  >
    <v-card class="dialogBackground">
      <v-card-text class="pt-4 primary--text">
        {{text}}
      </v-card-text>

      <v-card-actions class="pt-4 justify-center">
        <v-btn
          class="px-6"
          outlined
          @click.prevent="close(false)"
        >Отмена</v-btn>
        <v-btn
          class="px-12"
          color="primary"
          @click.prevent="close(true)"
        >ОК</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    text: '',
    show: false,
    resolve: null,
    dialogResult: false
  }),

  watch: {
    show: function (val) {
      if (val) {
        // open
        this.dialogResult = false
      } else {
        // close
        this.resolve && this.resolve(this.dialogResult)
      }
    }
  },

  methods: {
    showDialog (text) {
      return new Promise(resolve => {
        this.resolve = resolve
        this.text = text
        this.show = true
      })
    },

    close (val) {
      this.dialogResult = val
      this.show = false
    }
  },

  created () {
    Vue.prototype.$confirm = this.showDialog
  }
}
</script>
